import styled from '@emotion/styled';

import { font } from '../Font/Font.styles';

export const WatermarkText = styled.div`
  ${font('body-md')};
  position: absolute;
  top: 50%;
  right: 0;
  margin-right: 29px; // half of the element width (17px) + 12px of distance from the right
  transform: translate(50%, -50%) rotate(0.75turn);
  text-align: right;
  background: rgba(0, 0, 0, 0.5);
  padding: var(--spacing-8);
  color: var(--color-white);
  white-space: nowrap;
  overflow: hidden;
  max-height: 100%;
  border-radius: var(--border-radius-s);
  cursor: vertical-text;
`;

export const WatermarkImage = styled.div`
  display: flex;
  position: absolute;
  right: 0;
  bottom: 0;
  overflow: hidden;
  max-width: 150px;
  margin-right: var(--spacing-16);
  margin-bottom: var(--spacing-16);
  max-height: 100%;
  @media (max-width: 600px) {
    max-width: 100px;
  }
`;

export const BlurHashCanvas = styled.canvas`
  transition: opacity 0.2s;
  opacity: 1;
  display: flex;
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  overflow: hidden;
  max-height: 100%;
  width: 100%;
  height: 100%;
`;
